import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { FiSearch, FiX } from 'react-icons/fi';
import { usersAPI } from '../utils/api';

export default function Search() {
  const [query, setQuery]     = useState('');
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [suggestions, setSuggestions] = useState([]);
  const timerRef              = useRef();

  useEffect(() => {
    usersAPI.getSuggestions().then(r => setSuggestions(r.data.users || [])).catch(() => {});
  }, []);

  useEffect(() => {
    clearTimeout(timerRef.current);
    if (!query.trim()) { setResults([]); return; }
    setLoading(true);
    timerRef.current = setTimeout(async () => {
      try { const res = await usersAPI.searchUsers(query); setResults(res.data.users || []); }
      catch {}
      finally { setLoading(false); }
    }, 400);
    return () => clearTimeout(timerRef.current);
  }, [query]);

  const list = query ? results : suggestions;

  return (
    <div className="page-container" style={{ maxWidth: 600 }}>
      <div style={{ position: 'relative', marginBottom: 'var(--sp-4)' }}>
        <FiSearch style={{ position: 'absolute', left: 14, top: '50%', transform: 'translateY(-50%)', color: 'var(--text-3)', pointerEvents: 'none' }} />
        <input
          className="input"
          style={{ paddingLeft: 42, paddingRight: query ? 40 : 16 }}
          placeholder="Search users…"
          value={query}
          onChange={e => setQuery(e.target.value)}
          autoFocus
        />
        {query && (
          <button onClick={() => setQuery('')}
            style={{ position: 'absolute', right: 12, top: '50%', transform: 'translateY(-50%)', color: 'var(--text-3)', background: 'none', border: 'none', cursor: 'pointer', display: 'flex' }}>
            <FiX size={16} />
          </button>
        )}
      </div>

      {!query && (
        <p className="font-bold text-2" style={{ marginBottom: 'var(--sp-3)', fontSize: 'var(--fs-xs)', textTransform: 'uppercase', letterSpacing: '.5px' }}>
          Suggested
        </p>
      )}

      {loading && (
        <div style={{ display: 'flex', justifyContent: 'center', padding: 'var(--sp-5)' }}>
          <span className="spinner" />
        </div>
      )}

      {!loading && query && results.length === 0 && (
        <div style={{ textAlign: 'center', padding: 'var(--sp-6) var(--sp-4)', color: 'var(--text-3)' }}>
          <p style={{ fontSize: 'var(--fs-md)' }}>No users found for "{query}"</p>
        </div>
      )}

      <div style={{ display: 'flex', flexDirection: 'column', gap: 'clamp(4px,1vw,8px)' }}>
        {list.map(u => <UserRow key={u.id} user={u} />)}
      </div>
    </div>
  );
}

function UserRow({ user: u }) {
  const [following, setFollowing] = useState(u.is_following);
  const toggle = async e => {
    e.preventDefault();
    setFollowing(p => !p);
    try { await usersAPI.toggleFollow(u.id); }
    catch { setFollowing(p => !p); }
  };

  return (
    <Link to={`/profile/${u.id}`} className="card"
      style={{ display: 'flex', alignItems: 'center', gap: 'var(--sp-3)', padding: 'clamp(10px,2vw,14px) clamp(12px,2.5vw,18px)', textDecoration: 'none' }}>
      {u.avatar
        ? <img src={u.avatar} className="avatar" style={{ width: 'clamp(38px,8vw,48px)', height: 'clamp(38px,8vw,48px)' }} alt="" />
        : <div style={{ width: 'clamp(38px,8vw,48px)', height: 'clamp(38px,8vw,48px)', borderRadius: '50%', background: 'linear-gradient(135deg,#E91E8C,#7B2FF7)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff', fontWeight: 700, fontSize: 'clamp(15px,3vw,20px)', flexShrink: 0 }}>
            {u.full_name?.[0] || u.username?.[0]}
          </div>
      }
      <div style={{ flex: 1, minWidth: 0 }}>
        <p className="font-bold truncate" style={{ fontSize: 'var(--fs-sm)' }}>
          {u.username}
          {u.is_verified && <span style={{ color: 'var(--primary)', marginLeft: 4 }}>✓</span>}
        </p>
        <p style={{ color: 'var(--text-3)', fontSize: 'var(--fs-xs)' }} className="truncate">{u.full_name}</p>
      </div>
      <button onClick={toggle} className={'btn btn-sm ' + (following ? 'btn-outline' : 'btn-primary')} style={{ flexShrink: 0 }}>
        {following ? 'Following' : 'Follow'}
      </button>
    </Link>
  );
}
